<template>
  <div class="asd20-list" :class="classes">
    <div class="asd20-list__header" v-if="$slots.header || headline">
      <asd20-icon v-if="icon" :name="icon" :size="iconSize" />
      <component
        :is="headlineTag"
        class="asd20-list__headline"
        v-html="headline"
      ></component>
      <slot name="header" />
    </div>
    <asd20-viewport scrollable :max-height="maxHeight">
      <div class="asd20-list__items" :style="styles">
        <template v-for="(item, index) in items">
          <asd20-list-category
            v-if="item.type === 'category'"
            v-bind="type"
            :key="index"
          />
          <asd20-list-item v-else v-bind="item" :key="index" />
        </template>
        <slot />
      </div>
    </asd20-viewport>
    <div class="asd20-list__footer" v-if="$slots.footer">
      <slot name="footer" />
    </div>
    <!-- <resize-observer @notify="handleResize" /> -->
  </div>
</template>

<script>
// import { ResizeObserver } from 'vue-resize'
import Asd20Viewport from '../../../components/atoms/Asd20Viewport'
import Asd20Icon from '../../../components/atoms/Asd20Icon'
import Asd20ListItem from '../../../components/molecules/Asd20ListItem'
import Asd20ListCategory from '../../../components/molecules/Asd20ListCategory'

export default {
  name: 'Asd20List',

  data: () => ({
    columns: 1,
  }),

  components: {
    Asd20Viewport,
    Asd20Icon,
    Asd20ListItem,
    Asd20ListCategory,
    // ResizeObserver,
  },

  props: {
    headline: { type: String, default: '' },
    headlineTag: { type: String, default: 'h2' },
    /**
     * This is long form field
     */
    description: { type: String, default: '' },
    /**
     * to automap Asd20ListItem map your object for its props: label, thumbnail, textAvatar, description, badge, link, etc.
     */
    items: { type: Array, default: () => [] },
    icon: { type: String, default: '' },
    iconSize: { type: String, default: 'lg' },
    callToAction: { type: Object, default: null },
    multiColumn: { type: Boolean, default: false },
    columnWidth: { type: Number, default: 320 },
    maxHeight: { type: String, default: 'none' },
  },

  computed: {
    classes() {
      return {
        'asd20-list--multi-column': this.multiColumn && this.columns > 1,
        'asd20-list--label': this.label,
      }
    },
    styles() {
      return `--columns: ${this.columns}`
    },
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      this.columns = Math.round(this.$el.offsetWidth / this.columnWidth)
      // console.log(this.$el.offsetWidth, this.columnWidth, this.columns)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-list__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: space(0.5);
  .asd20-icon {
    margin-right: space(0.5);
    --line-color: var(--website-icon__line-color);
    --fill-color: var(--website-icon__fill-color);
  }
}

.asd20-list__headline {
  font-size: 1.25rem !important;
  color: var(--color__primary);
}

.asd20-list--multi-column {
  .asd20-list__items {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  &::v-deep .asd20-list-item {
    width: calc(100% / var(--columns));
    position: relative;
    word-break: normal;

    &--bordered {
      box-shadow: none !important;
    }
  }
}

// @media (min-width: 767px) {
//   .asd20-list--multi-column {
//     &::v-deep .asd20-list-item {
//       width: calc(100% / 2);
//     }
//   }
// }

// @media (min-width: 1024px) {
//   .asd20-list--multi-column {
//     &::v-deep .asd20-list-item {
//       width: calc(100% / 3);
//     }
//   }
// }
</style>